'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var graphqlTag = require('graphql-tag');

const getNotificationPreferencesAndLevelQuery = graphqlTag.gql`
  query GetNotificationPreferencesAndLevel(
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
    $referrerUrl: String
  ) {
    getNotificationPreferencesAndLevel(
      product: "global"
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
      referrerUrl: $referrerUrl
    ) {
      lineLoginUrl
      preferenceLevel
      modifiedDatetime
      isGuest
      isActive
      notificationPrefDetails {
        contact
        channel
      }
    }
  }
`;
graphqlTag.gql`
  mutation UpdateNotificationPreferencesAllLevels(
    $preferenceLevel: NotificationPreferenceLevel!
    $isActive: String
    $isGuest: String
    $channel: String
    $trackingNumber: String
    $orderId: String
    $modifiedDatetime: String
    $referrerUrl: String
    $notificationPrefDetails: [NotificationPrefDetailsInput]
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
    $marketingOptInChecked: Boolean
  ) {
    updateNotificationPreferencesAllLevels(
      preferenceLevel: $preferenceLevel
      isActive: $isActive
      isGuest: $isGuest
      channel: $channel
      trackingNumber: $trackingNumber
      orderId: $orderId
      modifiedDatetime: $modifiedDatetime
      referrerUrl: $referrerUrl
      notificationPrefDetails: $notificationPrefDetails
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
      marketingOptInChecked: $marketingOptInChecked
    )
  }
`;
graphqlTag.gql`
  mutation UnsubscribeNotificationPreferencesAllLevels(
    $preferenceLevel: NotificationPreferenceLevel!
    $isActive: String
    $isGuest: String
    $channel: String!
    $trackingNumber: String
    $orderId: String
    $modifiedDatetime: String
    $referrerUrl: String
    $notificationPrefDetails: [NotificationPrefDetailsInput]
    $retailerMoniker: String!
    $trackingNumbers: [String!]
    $orderNumbers: [String!]
    $versionName: String
    $carrier: String
    $type: String
    $orderApiEnabled: Boolean
    $localeCountry: Country
    $localeLanguage: Language
    $destinationZip: String
    $email: String
    $phone: String
    $token: String
    $secured: Boolean
    $originZip: String
    $originCountry: String
    $destinationCountry: String
    $service: String
    $orderDate: String
    $shipDate: String
    $retailerDcId: String
    $productCategory: String
    $promiseDate: String
    $hipaaCompliant: Boolean
  ) {
    unsubscribeNotificationPreferencesAllLevels(
      preferenceLevel: $preferenceLevel
      isActive: $isActive
      isGuest: $isGuest
      channel: $channel
      trackingNumber: $trackingNumber
      orderId: $orderId
      modifiedDatetime: $modifiedDatetime
      referrerUrl: $referrerUrl
      notificationPrefDetails: $notificationPrefDetails
      retailerMoniker: $retailerMoniker
      trackingNumbers: $trackingNumbers
      orderNumbers: $orderNumbers
      versionName: $versionName
      carrier: $carrier
      type: $type
      orderApiEnabled: $orderApiEnabled
      localeCountry: $localeCountry
      localeLanguage: $localeLanguage
      destinationZip: $destinationZip
      email: $email
      phone: $phone
      token: $token
      secured: $secured
      originZip: $originZip
      originCountry: $originCountry
      destinationCountry: $destinationCountry
      service: $service
      orderDate: $orderDate
      shipDate: $shipDate
      retailerDcId: $retailerDcId
      productCategory: $productCategory
      promiseDate: $promiseDate
      hipaaCompliant: $hipaaCompliant
    )
  }
`;
const getUserPrefsNotificationPreferences = graphqlTag.gql`
  query GetUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    getUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
    ) {
      optIns {
        level
        preferences {
          status
        }
      }
      profileId
    }
  }
`;
graphqlTag.gql`
  query GetUserPrefsNotificationPreferencesEligibility(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    getUserPrefsNotificationPreferencesEligibility(
      retailerMoniker: $retailerMoniker
      carrier: $carrier
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
    ) {
      eligible
    }
  }
`;
graphqlTag.gql`
  mutation SubscribeUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $notificationPrefDetails: [NotificationPrefDetailsInput!]!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
    $lineageMetadata: LineageMetadataInput!
  ) {
    subscribeUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
      notificationPrefDetails: $notificationPrefDetails
      lineageMetadata: $lineageMetadata
    ) {
      profileId
    }
  }
`;
graphqlTag.gql`
  mutation UnsubscribeUserPrefsNotificationPreferences(
    $retailerMoniker: String!
    $orderNumber: String
    $trackingNumber: String
    $carrier: String
  ) {
    unsubscribeUserPrefsNotificationPreferences(
      retailerMoniker: $retailerMoniker
      orderNumber: $orderNumber
      trackingNumber: $trackingNumber
      carrier: $carrier
    )
  }
`;

exports.getNotificationPreferencesAndLevelQuery = getNotificationPreferencesAndLevelQuery;
exports.getUserPrefsNotificationPreferences = getUserPrefsNotificationPreferences;
